"use strict";

exports.__esModule = true;
exports.KYCClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("../constants");
const KYCClient = {
  /**
   * @description Return the orders of a customer
   *
   * @param {Number} page
   * @param {Number} limit
   * @returns {Promise}
   */
  fetch({
    name
  }) {
    const requestId = 'HOTEL_CHAINS';
    return _http.$http.get(requestId, _constants.ENDPOINTS.HOTEL_CHAINS, {
      params: {
        page: 1,
        limit: 100,
        name
      }
    }).then(({
      data
    }) => data);
  },
  fetchInterests() {
    const requestId = 'INTERESTS';
    return _http.$http.get(requestId, _constants.ENDPOINTS.INTERESTS).then(({
      data
    }) => data);
  },
  postPrefrences(data) {
    const requestId = 'POST_PREFRENCES';
    const endPoint = _constants.ENDPOINTS.SAVE_PREFRENCES;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  },
  getPrefrences(types) {
    const requestId = 'GET_PREFRENCES';
    const endPoint = _constants.ENDPOINTS.GET_PREFRENCES;
    return _http.$http.get(requestId, endPoint, {
      params: {
        types
      }
    }).then(({
      data
    }) => data);
  },
  getPrefrencesStatus() {
    const requestId = 'GET_PREFRENCES_STATUS';
    const endPoint = _constants.ENDPOINTS.GET_PREFRENCES_STATUS;
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  getAirlines({
    name
  }) {
    const requestId = 'FETCH_AIRLINES';
    const endPoint = _constants.ENDPOINTS.GET_AIRLINES;
    return _http.$http.get(requestId, endPoint, {
      params: {
        name
      }
    }).then(({
      data
    }) => data);
  }
};
exports.KYCClient = KYCClient;